"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressField = void 0;
var nebula_1 = require("@ovotech/nebula");
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var copy_1 = require("./copy");
var AddressField = function (_a) {
    var id = _a.id, value = _a.value, _b = _a.errors, errors = _b === void 0 ? [] : _b, onChange = _a.onChange;
    var _c = (0, __1.useComponents)(), TextField = _c.TextField, Stack = _c.Stack;
    var copy = (0, __1.useCopy)(copy_1.defaultOptions).copy;
    var handleChange = function (key) { return function (event) {
        var _a;
        return onChange(__assign(__assign({}, value), (_a = {}, _a[key] = event.target.value, _a)));
    }; };
    return (react_1.default.createElement("fieldset", { id: id, "data-testid": "address-field" },
        react_1.default.createElement(Stack, { spaceBetween: [3, 6] },
            react_1.default.createElement(TextField, { id: "".concat(id, "-line1"), "data-testid": "line-1", label: copy('addressField.line1'), fullWidth: "always", error: (0, nebula_1.getErrorMessage)("".concat(id, "-line1"), errors), value: value.line1, onChange: handleChange('line1') }),
            react_1.default.createElement(TextField, { id: "".concat(id, "-line2"), "data-testid": "line-2", label: copy('addressField.line2'), fullWidth: "always", error: (0, nebula_1.getErrorMessage)("".concat(id, "-line2"), errors), optional: true, value: value.line2, onChange: handleChange('line2') }),
            react_1.default.createElement(TextField, { id: "".concat(id, "-town"), "data-testid": "town", label: copy('addressField.town'), error: (0, nebula_1.getErrorMessage)("".concat(id, "-town"), errors), value: value.town, onChange: handleChange('town') }),
            react_1.default.createElement(TextField, { id: "".concat(id, "-postcode"), "data-testid": "postcode", label: copy('addressField.postcode'), error: (0, nebula_1.getErrorMessage)("".concat(id, "-postcode"), errors), value: value.postcode, onChange: handleChange('postcode') }))));
};
exports.AddressField = AddressField;
